import request from '@/utils/request';
import Resource from '@/api/resource';
class RolesResource extends Resource {
  constructor() {
    super('roles');
  }

  // 获取权限列表
  getRolesApi(data) {
    return request({
      url: `/${this.uri}/`,
      method: 'GET',
      params: data,
    });
  }

  // 获取角色所拥有权限
  getRolePermissionsApi(id) {
    return request({
      url: `/${this.uri}/${id}/permissions`,
      method: 'GET',
    });
  }

  // 获取指定role信息
  getRoleInfoApi(id) {
    return request({
      url: `/${this.uri}/${id}`,
      method: 'GET',
    });
  }

  // 修改角色权限
  editApi(data, id) {
    return request({
      url: `/${this.uri}/${id}/update`,
      method: 'POST',
      data,
    });
  }

  /**
   * 获取角色游戏接口
   * @param {number} role_id 角色ID
   */
  getRoleGamesApi(role_id) {
    return request({
      url: `/${this.uri}/${role_id}/games`,
      method: 'get',
    });
  }

  /**
   * 分配角色游戏接口
   * @param {number} role_id 角色ID
   * @param {{game_ids: number[]}} data 请求体
   */
  assignGamePermissionApi(role_id, data) {
    return request({
      url: `/${this.uri}/${role_id}/games`,
      method: 'POST',
      data,
    });
  }
}

export { RolesResource as default };
